export const PREFIX_PHONE: string = '+38 ';
